
/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AutoEdrBlacklistedDomainRequest,
  AutoEdrBlacklistedDomains,
  DeleteEdrFromOrganizationRequest,
  OrganizationWithEdrBlacklisted,
} from '../models';
import {
    AutoEdrBlacklistedDomainRequestFromJSON,
    AutoEdrBlacklistedDomainRequestToJSON,
    AutoEdrBlacklistedDomainsFromJSON,
    AutoEdrBlacklistedDomainsToJSON,
    DeleteEdrFromOrganizationRequestFromJSON,
    DeleteEdrFromOrganizationRequestToJSON,
    OrganizationWithEdrBlacklistedFromJSON,
    OrganizationWithEdrBlacklistedToJSON,
} from '../models';

export interface AddAutoEdrBlacklistedDomainRequest {
    autoEdrBlacklistedDomainRequest: AutoEdrBlacklistedDomainRequest;
}

export interface CheckDomainRequest {
    domain: string;
}

export interface DeleteAutoEdrBlacklistedDomainRequest {
    domain: string;
}

export interface RemoveEdrFromOrganizationsRequest {
    deleteEdrFromOrganizationRequest: DeleteEdrFromOrganizationRequest;
}

/**
 * 
 */
export class AutoEdrBlacklistedDomainApi extends runtime.BaseAPI {

    /**
     * Add a new blacklisted domain for the feature auto edr
          */
    async addAutoEdrBlacklistedDomainRaw(requestParameters: AddAutoEdrBlacklistedDomainRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['autoEdrBlacklistedDomainRequest'] == null) {
            throw new runtime.RequiredError(
                'autoEdrBlacklistedDomainRequest',
                'Required parameter "autoEdrBlacklistedDomainRequest" was null or undefined when calling addAutoEdrBlacklistedDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/signup-client/api/admin/auto-edr-blacklisted-domain`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutoEdrBlacklistedDomainRequestToJSON(requestParameters['autoEdrBlacklistedDomainRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Add a new blacklisted domain for the feature auto edr
          */
    async addAutoEdrBlacklistedDomain(requestParameters: AddAutoEdrBlacklistedDomainRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.addAutoEdrBlacklistedDomainRaw(requestParameters, initOverrides);
    }

    /**
     * Check if a domain is blacklisted
          */
    async checkDomainRaw(requestParameters: CheckDomainRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<boolean>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling checkDomain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['domain'] != null) {
            queryParameters['domain'] = requestParameters['domain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<boolean>({
            path: `/signup-client/api/admin/auto-edr-blacklisted-domain/check`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Check if a domain is blacklisted
          */
    async checkDomain(requestParameters: CheckDomainRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.checkDomainRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Ask for the computation of organization that have at least one domain in EDR that is blacklisted
          */
    async computeOrganizationWithEdrBlacklistedRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/signup-client/api/admin/auto-edr-blacklisted-domain/synchronize`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Ask for the computation of organization that have at least one domain in EDR that is blacklisted
          */
    async computeOrganizationWithEdrBlacklisted(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.computeOrganizationWithEdrBlacklistedRaw(initOverrides);
    }

    /**
     * Delete a blacklisted domain for the feature auto edr
          */
    async deleteAutoEdrBlacklistedDomainRaw(requestParameters: DeleteAutoEdrBlacklistedDomainRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling deleteAutoEdrBlacklistedDomain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['domain'] != null) {
            queryParameters['domain'] = requestParameters['domain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/signup-client/api/admin/auto-edr-blacklisted-domain`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete a blacklisted domain for the feature auto edr
          */
    async deleteAutoEdrBlacklistedDomain(requestParameters: DeleteAutoEdrBlacklistedDomainRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAutoEdrBlacklistedDomainRaw(requestParameters, initOverrides);
    }

    /**
     * Get all the blacklisted domain for the feature auto edr
          */
    async getAllAutoEdrBlacklistedDomainsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AutoEdrBlacklistedDomains>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AutoEdrBlacklistedDomains>({
            path: `/signup-client/api/admin/auto-edr-blacklisted-domain`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AutoEdrBlacklistedDomainsFromJSON(response._data); }
        return response;
    }

    /**
     * Get all the blacklisted domain for the feature auto edr
          */
    async getAllAutoEdrBlacklistedDomains(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AutoEdrBlacklistedDomains> {
        const response = await this.getAllAutoEdrBlacklistedDomainsRaw(initOverrides);
        return response._data;
    }

    /**
     * Given a list of organizationIds, remove every domain in EDR that should be blacklisted
          */
    async removeEdrFromOrganizationsRaw(requestParameters: RemoveEdrFromOrganizationsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['deleteEdrFromOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteEdrFromOrganizationRequest',
                'Required parameter "deleteEdrFromOrganizationRequest" was null or undefined when calling removeEdrFromOrganizations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/signup-client/api/admin/auto-edr-blacklisted-domain/synchronize`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteEdrFromOrganizationRequestToJSON(requestParameters['deleteEdrFromOrganizationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Given a list of organizationIds, remove every domain in EDR that should be blacklisted
          */
    async removeEdrFromOrganizations(requestParameters: RemoveEdrFromOrganizationsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeEdrFromOrganizationsRaw(requestParameters, initOverrides);
    }

    /**
     * Return a list of organization that have at least one domain in EDR that is blacklisted
          */
    async synchronizeOrganizationsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<OrganizationWithEdrBlacklisted>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<OrganizationWithEdrBlacklisted>>({
            path: `/signup-client/api/admin/auto-edr-blacklisted-domain/synchronize`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(OrganizationWithEdrBlacklistedFromJSON);
        return response;
    }

    /**
     * Return a list of organization that have at least one domain in EDR that is blacklisted
          */
    async synchronizeOrganizations(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<OrganizationWithEdrBlacklisted>> {
        const response = await this.synchronizeOrganizationsRaw(initOverrides);
        return response._data;
    }

}
